/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BusinessReportAppsNetSalesResponse
 */
export interface BusinessReportAppsNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BusinessReportAppsNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BusinessReportAppsNetSalesResponse interface.
 */
export function instanceOfBusinessReportAppsNetSalesResponse(value: object): value is BusinessReportAppsNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportAppsNetSalesResponseFromJSON(json: any): BusinessReportAppsNetSalesResponse {
    return BusinessReportAppsNetSalesResponseFromJSONTyped(json, false);
}

export function BusinessReportAppsNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportAppsNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BusinessReportAppsNetSalesResponseToJSON(json: any): BusinessReportAppsNetSalesResponse {
    return BusinessReportAppsNetSalesResponseToJSONTyped(json, false);
}

export function BusinessReportAppsNetSalesResponseToJSONTyped(value?: BusinessReportAppsNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

